import { render, staticRenderFns } from "./RowLargeScreen.vue?vue&type=template&id=2851eed6&"
import script from "./RowLargeScreen.vue?vue&type=script&lang=js&"
export * from "./RowLargeScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2851eed6')) {
      api.createRecord('2851eed6', component.options)
    } else {
      api.reload('2851eed6', component.options)
    }
    module.hot.accept("./RowLargeScreen.vue?vue&type=template&id=2851eed6&", function () {
      api.rerender('2851eed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/files/RowLargeScreen.vue"
export default component.exports